import { render, staticRenderFns } from "./WorksDistribution.vue?vue&type=template&id=f9e7879a&scoped=true"
import script from "./WorksDistribution.vue?vue&type=script&lang=js"
export * from "./WorksDistribution.vue?vue&type=script&lang=js"
import style0 from "./WorksDistribution.vue?vue&type=style&index=0&id=f9e7879a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e7879a",
  null
  
)

export default component.exports